export default {
  pageSize: (state) => state.pageSize,
  searchTerm: (state) => state.searchTerm,
  filterOptions: (state) => state.filterOptions,
  filterBy: (state) => state.filterBy,
  sortDir: (state) => state.sortDir,
  orderBy: (state) => state.orderBy,
  adass: (state) => state.adass,
  adas: (state) => state.adas,
  adasInspections: (state) => state.adasInspections,
  adasInspection: (state) => state.adasInspection,
  highlightSave: (state) => state.highlightSave,
  isAdasChecked: (state) => state.isAdasChecked,
  adasInspectionResults: (state) => state.adasInspectionResults,
  reportPreference: (state) => state.reportPreference,
  adasInspectionItems: (state) => state.adasInspectionItems,
  adasDecodeInfo: (state) => state.adasDecodeInfo,
  links: (state) => state.links,
  decoded: (state) => state.decoded,
  repairlines: (state) => state.repairlines,
  requests: (state) => state.requests,
  request: (state) => state.request,
  adasNotInstalled: (state) => state.adasNotInstalled,
}



// WEBPACK FOOTER //
// ./src/store/modules/adas/getters.js